import React, { useEffect, useState } from 'react';
import { countries } from '../../utils/countries';
import './country_picker.scss';

interface Props {
  showCities?: boolean;
  allCountriesOption?: string;
  allCitiesOption?: string;
  countriesLabel?: string;
  citiesLabel?: string;
  selectedCountry?: string;
  selectedCity?: string;
  onCountrySelect?: (country: string) => void;
  onCitySelect?: (city: string) => void;
  countryRef?: any;
  cityRef?: any;
}

const CountryPicker: React.FC<Props> = (props) => {
  const {
    showCities,
    allCountriesOption,
    allCitiesOption,
    countriesLabel,
    citiesLabel,
    selectedCountry,
    selectedCity,
    onCountrySelect,
    onCitySelect,
    countryRef,
    cityRef
  } = props;

  const [cities, setCities] = useState<string[]>([]);

  useEffect(() => {
    onCountryPicked((allCountriesOption && 'all') || countries[0].nameAr);
  }, []);

  const onCountryPicked = (country: string) => {
    if (!country) return;

    if (country === 'all') {
      setCities([]);
    } else {
      const countryObject = countries.find((c) => c.nameAr === country);
      setCities(countryObject!.cities);
    }

    if (onCountrySelect) onCountrySelect(country);
  };

  const onCityPicked = (city: string) => {
    if (!city) return;

    if (onCitySelect) onCitySelect(city);
  };

  return (
    <div className="picker-container">
      <div className="country-menu">
        {countriesLabel && <span className="label">{countriesLabel}</span>}
        <select
          name="country"
          value={selectedCountry || 'all'}
          onChange={(e) => {
            onCountryPicked(e.target.value);
          }}
          ref={countryRef}
        >
          {allCountriesOption && (
            <option value="all" label={allCountriesOption} />
          )}
          {countries.map((country) => {
            return <option value={country.nameAr} label={country.nameAr} />;
          })}
        </select>
      </div>

      <div>
        {citiesLabel && <span className="label">{citiesLabel}</span>}
        {showCities && (
          <select
            name="city"
            value={selectedCity || 'all'}
            onChange={(e) => onCityPicked(e.target.value)}
            ref={cityRef}
          >
            {allCitiesOption && <option value="all" label={allCitiesOption} />}
            {cities.map((city) => {
              return <option value={city} label={city} />;
            })}
          </select>
        )}
      </div>
    </div>
  );
};

export default CountryPicker;
